'use strict';

angular.module('studies')
    .component('studiesTableItem', {
        templateUrl: 'js/modules/studies/components/table-item/template.html',
        controller: 'StudiesTableItemController',
        bindings: {
            item: '<',
        },
    });
